'use client'

import * as React from 'react'

import cn from '@config/tailwind/cn'

interface CanvaIframeBlockFields {
  blockType: 'canva-iframe'
  embedUrl: string
  title?: string
  description?: string
}

interface CanvaIframeBlockProps {
  fields: CanvaIframeBlockFields
}

export function CanvaIframeBlock({ fields }: CanvaIframeBlockProps) {
  return (
    <div className='ui:my-6'>
      {fields.title && <h5 className='ui:mb-3 ui:text-lg ui:font-semibold ui:text-neutral-black'>{fields.title}</h5>}
      <div className='ui:relative ui:aspect-4/3 ui:w-full ui:overflow-hidden ui:rounded-xl ui:shadow-lg'>
        <iframe
          src={fields.embedUrl}
          title={fields.title ?? 'Canva embed'}
          allowFullScreen
          loading='lazy'
          className='ui:absolute ui:inset-0 ui:h-full ui:w-full'
        />
      </div>
      {fields.description && (
        <p className={cn('ui:mt-2 ui:text-sm ui:text-center ui:text-grey-100')}>{fields.description}</p>
      )}
    </div>
  )
}
